import { ComponentProps } from 'react'

import { TSearchFilter, useSearchFilterStore } from '@/entities/map'
import { Filter, useFilterOptions } from '@/features/room-filter'

import { FilterDialogTrigger } from '../filter-dialog'

type FilterMenuItemProps = {
  title: string
  type: ComponentProps<typeof FilterDialogTrigger>['target']
  field: (keyof TSearchFilter)[]
  width: number
}

const FilterMenuItem = ({ title, type, field, width }: FilterMenuItemProps) => {
  const isChanged = useSearchFilterStore(state => state.hasChanged(field))

  return (
    <FilterDialogTrigger target={type}>
      <Filter.Item width={width} selected={isChanged}>
        {title}
      </Filter.Item>
    </FilterDialogTrigger>
  )
}

export const FilterMenuList = () => {
  const { FILTER_OPTIONS } = useFilterOptions()

  return (
    <div className="mr-4 flex gap-1.5">
      <FilterDialogTrigger>
        <Filter.All />
      </FilterDialogTrigger>

      {FILTER_OPTIONS.map(option => (
        <FilterMenuItem key={option.type} {...option} />
      ))}
    </div>
  )
}
